var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { COMPETITIONS_FORM } from '../../constants/cmsResourceTypes';
import CompetitionForm from './CompetitionsForm';
const CompetitionsForm = (_a) => {
    var { onFormSubmit } = _a, props = __rest(_a, ["onFormSubmit"]);
    if (!onFormSubmit) {
        throw new Error('CompetitionsForm must be passed onFormSubmit');
    }
    return React.createElement(CompetitionForm, Object.assign({ onFormSubmit: onFormSubmit }, props));
};
CompetitionsForm.resourceType = COMPETITIONS_FORM;
export default CompetitionsForm;
//# sourceMappingURL=index.js.map